import { render, staticRenderFns } from "./PxfAnimationCard.vue?vue&type=template&id=4e68f0e9&scoped=true"
import script from "./PxfAnimationCard.vue?vue&type=script&lang=js"
export * from "./PxfAnimationCard.vue?vue&type=script&lang=js"
import style0 from "./PxfAnimationCard.vue?vue&type=style&index=0&id=4e68f0e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e68f0e9",
  null
  
)

export default component.exports